export default __webpack_public_path__ + "static/media/search.d4b0a8bc.svg";